class KlaviyoBis extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.trigger = this.querySelector('[data-open-bis]');
    if (!this.trigger) return;

    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.openModal();
    });

    this.createModal();
    this.setupEventListeners();
  }

  createModal() {
    this.modal = document.createElement('div');
    this.modal.className = 'klaviyo-bis-modal';
    this.modal.innerHTML = `
      <div class="klaviyo-bis-modal__content">
        <button class="klaviyo-bis-modal__close" aria-label="Close">×</button>
        <h2>Get notified when back in stock</h2>
        <p>Register to receive a notification when this item is available.</p>
        <form class="klaviyo-bis-form">
          <div class="klaviyo-bis-form__field">
            <label for="klaviyo-bis-email">Email</label>
            <input type="email" id="klaviyo-bis-email" required>
          </div>
          <div class="klaviyo-bis-form__field">
            <label class="klaviyo-bis-form__checkbox">
              <input type="checkbox" id="klaviyo-bis-consent">
              <span>${this.dataset.consentText}</span>
            </label>
          </div>
          <button type="submit" class="button">Notify me when available</button>
        </form>
        <div class="klaviyo-bis-form__success" hidden>
          You're in! We'll let you know when it's back.
        </div>
      </div>
    `;
    document.body.appendChild(this.modal);
  }

  setupEventListeners() {
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });

    this.modal.querySelector('.klaviyo-bis-modal__close')
      .addEventListener('click', () => this.closeModal());

    this.modal.querySelector('.klaviyo-bis-form')
      .addEventListener('submit', (e) => this.handleSubmit(e));
  }

  openModal() {
    this.modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  resetForm() {
    const form = this.modal.querySelector('.klaviyo-bis-form');
    const success = this.modal.querySelector('.klaviyo-bis-form__success');
    form.hidden = false;
    success.hidden = true;
    form.reset();
  }

  async handleSubmit(e) {
    e.preventDefault();
    const email = this.modal.querySelector('#klaviyo-bis-email').value;
    const hasConsent = this.modal.querySelector('#klaviyo-bis-consent').checked;
    const variantInput = document.querySelector('.product-variant-id');
    
    if (!variantInput) {
      console.error('Variant ID input not found');
      alert('Unable to process your request. Please try again.');
      return;
    }

    const variantId = variantInput.value;

    try {
      const bisResponse = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.dataset.klaviyoKey}`,
        {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: this.dataset.bisRevision,
            'content-type': 'application/vnd.api+json'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email
                    }
                  }
                },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`
                  }
                }
              }
            }
          })
        }
      );

      if (bisResponse.status !== 202) throw new Error('Failed to subscribe to back in stock');

      if (hasConsent) {
        const listResponse = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${this.dataset.klaviyoKey}`,
          {
            method: 'POST',
            headers: {
              accept: 'application/vnd.api+json',
              revision: this.dataset.bisRevision,
              'content-type': 'application/vnd.api+json'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email
                      }
                    }
                  },
                  custom_source: 'Back in Stock'
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: this.dataset.listId
                    }
                  }
                }
              }
            })
          }
        );

        if (listResponse.status !== 202) throw new Error('Failed to subscribe to list');
      }

      const form = this.modal.querySelector('.klaviyo-bis-form');
      const success = this.modal.querySelector('.klaviyo-bis-form__success');
      form.hidden = true;
      success.hidden = false;

      setTimeout(() => {
        this.closeModal();
        this.resetForm();
      }, 2000);

    } catch (error) {
      console.error('Error:', error);
      alert('Unable to process your request. Please try again.');
    }
  }
}

if (!customElements.get('klaviyo-bis')) {
  customElements.define('klaviyo-bis', KlaviyoBis);
}
